import {FC} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useTranslation} from 'react-i18next'
import {withProtectedRoute} from '../../../../utils/withProtectedRoute'
import {useValidateToken} from 'src/hooks/useValidateToken'
import {Table} from './Table'

export const CheckStock: FC = withProtectedRoute(() => {
  useValidateToken()

  const {t} = useTranslation()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('check-stock')}</PageTitle>
      <Table/>
    </>
  )
})
